import { useRecoilValue } from "recoil";
import { useState } from "react";
import { Restaurant } from "../../../../../api/types";
import { geoCoordState } from "../../../../../recoil/geo";
import { getDistanceKm } from "../../../../../utils/common";
import {
  PubRestaurantWrapper,
  PubRestaurantListWrapper,
  PubRestaurantItemWrapper,
  PubRestaurantItemLocation,
} from "./style";
import PremiumPubRestaurantMore from "./components/more";
import { usePubContext } from "../../hooks/pub-context";

const PremiumPubRestaurant = () => {
  const { data } = usePubContext();
  const { latitude, longitude } = useRecoilValue(geoCoordState);
  const [openMore, setOpenMore] = useState(false);
  const [item, setItem] = useState<Restaurant | null>(null);

  return (
    <PubRestaurantWrapper>
      <div className="title">주변 맛집</div>
      <PubRestaurantListWrapper>
        {data?.restaurant.length === 0 ? (
          <div className="no-data">등록된 맛집이 없습니다.</div>
        ) : (
          data?.restaurant.map((item, index) => (
            <PubRestaurantItemWrapper
              key={index}
              onClick={() => {
                setItem(item);
                setOpenMore(!openMore);
              }}
            >
              <img src={item.imageUrl} alt={item.restaurantName} />
              <div className="title">{item.restaurantName}</div>
              <div className="menu">
                대표메뉴: {item.menu}{" "}
                <span>{Number(item.menuPrice).toLocaleString()}원</span>
              </div>
              <PubRestaurantItemLocation>
                <img
                  alt="icon"
                  className="icon"
                  src="/image-web/Icon/Map%20pin/small.svg"
                />
                <span className="text">
                  {getDistanceKm(latitude, longitude, item.lat, item.lon)} km
                </span>
              </PubRestaurantItemLocation>
            </PubRestaurantItemWrapper>
          ))
        )}
      </PubRestaurantListWrapper>
      {openMore && (
        <PremiumPubRestaurantMore
          data={item}
          setShowMoreOption={setOpenMore}
          setSelectedStore={setItem}
        />
      )}
    </PubRestaurantWrapper>
  );
};

export default PremiumPubRestaurant;
